const esES = {
    crossmintPayButtonService: {
        CONNECTING: "Conectando...",
        BUY: "Comprar con Crossmint",
        BUY_WITH_ETH: "Comprar con ETH",
        BUY_WITH_SOL: "Comprar con SOL",
        BUY_WITH_CREDIT_CARD: "Comprar con tarjeta de crédito",
    },
};
export default esES;
